import { IconButton, Tooltip } from "@mui/material";
import {
  NotificationsActiveOutlined,
  NotificationsOffOutlined,
} from "@mui/icons-material";
import { useUIStore } from "../../views/assistant/stores/UIStore";

/**
 * AutoOpenToggle - Toggle button for auto-open sidebar preference
 *
 * Allows users to enable/disable automatic sidebar opening when new content arrives
 */
const AutoOpenToggle = () => {
  const { preferences, toggleAutoOpenSidebar } = useUIStore();
  const autoOpenEnabled = preferences?.autoOpenSidebar ?? true;

  return (
    <Tooltip
      title={
        autoOpenEnabled
          ? "Auto-open sidebar enabled - click to disable"
          : "Auto-open sidebar disabled - click to enable"
      }
    >
      <IconButton
        size="small"
        onClick={toggleAutoOpenSidebar}
        sx={{
          ml: 1,
          border: "1px solid",
          borderColor: autoOpenEnabled ? "primary.main" : "grey.400",
          borderRadius: 1,
          p: 0.5,
        }}
        data-testid="aa-auto-open-sidebar-toggle"
      >
        {autoOpenEnabled ? (
          <NotificationsActiveOutlined fontSize="small" color="primary" />
        ) : (
          <NotificationsOffOutlined fontSize="small" color="disabled" />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default AutoOpenToggle;
